import axios from 'axios';

import { buildEndpoint, getAuthToken } from '@services/service';
import { PurchaseSubscription } from '@app-types/subscription.type';

const BASE_URL = process.env.REACT_APP_PAYMENTS_URL as string;

const createAdminSubscription = async (req: PurchaseSubscription) => {
    try {
        const url = buildEndpoint(BASE_URL, 'api/admin/subscriptions');
        const response = await axios.post(url.toString(), req, {
            headers: { Authorization: getAuthToken() },
        });
        return response.data;
    } catch (err) {
        console.error('Error creating admin subscription:', err);
        return null;
    }
};

export { createAdminSubscription };
